import React from 'react';
import Skeleton from 'react-loading-skeleton';

import * as S from './styles';

const SkeletonLoading: React.FC = () => {
  return (
    <S.HeaderWrapper>
      <Skeleton width={86} height={24} />

      <Skeleton width={186} height={42} />
    </S.HeaderWrapper>
  );
};

export default SkeletonLoading;
